import { render, staticRenderFns } from "./MonthlyValuationCmdty.vue?vue&type=template&id=14aa7a16&scoped=true&"
import script from "./MonthlyValuationCmdty.vue?vue&type=script&lang=js&"
export * from "./MonthlyValuationCmdty.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyValuationCmdty.vue?vue&type=style&index=0&id=14aa7a16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14aa7a16",
  null
  
)

export default component.exports